module.exports = __webpack_public_path__ + "img/marketing-9.c5da5110.svg";